import { observer } from 'mobx-react';
import React from 'react';
import { Link, PromiseMessage, PromiseRetry, routerStore } from 'lib/components';
import { dateFormat, msToHumanTime, ReactNodeGenerator } from 'lib/helpers';
import {pagedListResponseUtils, PagedListResponse} from '../../../domain';
import { routes } from 'pages/Routes';
import { ExamTeacherListSceneStore } from './ExamTeacherListSceneStore';
import { ExamStudentListResponseItem } from 'scenes/exam/ExamModels';
import { EssayStatus } from 'domain/enums';
import Swal from 'sweetalert2';
import { EssaySelect } from 'lib/components/select/EssayStatusSelect';

@observer
export class ExamTeacherListScene extends React.Component {
  store: ExamTeacherListSceneStore;

  constructor(props: any) {
    super(props);
    this.store = new ExamTeacherListSceneStore();
  }

  componentDidMount() {
    this.store.load();
  }

  render() {
    return Array.from(this.renderer(this.store));
  }

  *renderRows(store: ExamTeacherListSceneStore): ReactNodeGenerator {
    if (store.loader?.isResolved !== true)
      return;

    const examItems = store.loader.value.Items;

    for (let item of examItems) {

      yield (
        <tr key={item.ExamId}>
          <td>
            {item.ExamId}
          </td>
          <td>
            {item.TeacherName}
          </td>         
          <td>
            {dateFormat(item.CreatedAt, 'wymdhm', true)}
          </td>
          <td>
            {item.StatusStr}
          </td>
          <td>
            <button type='button' className="btn btn-primary" onClick={(e) => this.onEssayOpenBtnClick(e, item)}>
              Open
            </button>
          </td>
        </tr>
      );
    }
  }

  *renderer(store: ExamTeacherListSceneStore): ReactNodeGenerator {
    if (store.loader == null)
      return;
    const state = store.loader;

    yield (<PromiseMessage key="loader-state"
      label="Loading schedule" state={state} align="right" />);

    yield (<PromiseRetry key="retry-actions"
      state={state} retry={store.load} align="right" />);

    if (!state.isResolved)
      return;

    const examItems = state.value.Items;
    const examRespons : PagedListResponse<ExamStudentListResponseItem> =
    {      
      PageSize:8,
      CurrentPage: store.currentPage,
      CountRecords: state.value.AllItemsCount,
      Data: examItems,
    };    

   
    if (examItems.length === 0) {
      yield (
        <div className="row justify-content-center" key="no-classrooms">
          <div className="col-auto">
            <div className="alert alert-info">You have no exam</div>
          </div>
        </div>
      );
      return;
    }

    yield (
      <div className="row" key="schedule">
        <div className="col">
          <table className="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th> Number</th>
                <th> Teacher</th>                
                <th> Create Date</th>
                <th> Status</th>
                <th> Action</th>
              </tr>
            </thead>
            <tbody>
              {Array.from(this.renderRows(store))}
            </tbody>
          </table>
        </div>
      </div>);
  }

  componentWillUnmount() {
    this.store.dispose();
  }

  onEssayOpenBtnClick = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, essay: ExamStudentListResponseItem) => {
    let link: string;
    
    link = routes.ExamTeachertLink(essay.ExamId);
    routerStore.navigateTo(link);
  }
}
